import React from "react";
import LogJobList from "./LogJobList";

import { useLogJobData } from "../../providers/LogJobDataProvider";

const LogJobsParentComponent: React.FC = () => {
  const { data, loading, error } = useLogJobData();
  if (loading) {
    return <div className="loading-indicator">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error: {error.message}</div>;
  }
          const {
            getLocationList,
            getMachineList,
            getUsers,
            getMarketingMaterials,
            getLocationTypes
          } =  data || {};

          return (
            <LogJobList
              machines={getMachineList}
              locations={getLocationList}
              users={getUsers}
              locationTypes ={getLocationTypes}
              marketingMaterials={getMarketingMaterials}
            />
          );
  }

export default LogJobsParentComponent;
